import * as React from 'react';
import FlowNameLabel from 'flow-doctor-lib/components/common/FlowNameLabel';
import { getCanvasUrl } from 'flow-doctor-lib/utils/urls';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const ViewFlowLink = ({
  marginInlineStart,
  portalId,
  flowId,
  shouldUseWorkflowName = false
}) => {
  return /*#__PURE__*/_jsx(Link, {
    external: true,
    marginInlineStart: marginInlineStart || '0',
    href: getCanvasUrl({
      portalId,
      flowId
    }),
    children: shouldUseWorkflowName ? /*#__PURE__*/_jsx(FlowNameLabel, {
      portalId: Number(portalId),
      flowId: Number(flowId)
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.header.view"
    })
  });
};
export default ViewFlowLink;